if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;

        this.form.addEventListener(
          'submit',
          this.onSubmitHandler.bind(this)
        );

        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        this.submitButton =
          this.querySelector('[type="submit"]');

        this.submitButtonText =
          this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute(
            'aria-haspopup',
            'dialog'
          );
        }

        this.hideErrors =
          this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();

        if (
          this.submitButton.getAttribute(
            'aria-disabled'
          ) === 'true'
        ) {
          return;
        }

        if (this.checkingCartVariants) return;

        this.checkingCartVariants = true;

        const hasAnotherVariant =
          await this.hasAnotherVariantInCart();

        this.checkingCartVariants = false;

        const selectedVariantId = Number(
          this.variantIdInput.value
        );

        if (
          hasAnotherVariant &&
          this.confirmedVariantId !== selectedVariantId
        ) {
          this.showSizeVariantWarning(
            selectedVariantId
          );

          return;
        }

        this.hideSizeVariantWarning();
        this.confirmedVariantId = null;

        this.handleErrorMessage();

        this.submitButton.setAttribute(
          'aria-disabled',
          true
        );

        this.submitButton.classList.add('loading');

        this.querySelector('.loading__spinner')
          .classList.remove('hidden');

        const config = fetchConfig('javascript');

        config.headers['X-Requested-With'] =
          'XMLHttpRequest';

        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart
              .getSectionsToRender()
              .map((section) => section.id)
          );

          formData.append(
            'sections_url',
            window.location.pathname
          );

          this.cart.setActiveElement(
            document.activeElement
          );
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId:
                  formData.get('id'),
                errors:
                  response.errors ||
                  response.description,
                message: response.message,
              });

              this.handleErrorMessage(
                response.description
              );

              const soldOutMessage =
                this.submitButton.querySelector(
                  '.sold-out-message'
                );

              if (!soldOutMessage) return;

              this.submitButton.setAttribute(
                'aria-disabled',
                true
              );

              this.submitButtonText.classList.add(
                'hidden'
              );

              soldOutMessage.classList.remove(
                'hidden'
              );

              this.error = true;

              return;
            } else if (!this.cart) {
              window.location =
                window.routes.cart_url;

              return;
            }

            if (!this.error) {
              publish(
                PUB_SUB_EVENTS.cartUpdate,
                {
                  source: 'product-form',
                  productVariantId:
                    formData.get('id'),
                  cartData: response,
                }
              );
            }

            this.error = false;

            const quickAddModal =
              this.closest('quick-add-modal');

            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(
                      response
                    );
                  });
                },
                { once: true }
              );

              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.submitButton.classList.remove(
              'loading'
            );

            if (
              this.cart &&
              this.cart.classList.contains(
                'is-empty'
              )
            ) {
              this.cart.classList.remove(
                'is-empty'
              );
            }

            if (!this.error) {
              this.submitButton.removeAttribute(
                'aria-disabled'
              );
            }

            this.querySelector(
              '.loading__spinner'
            ).classList.add('hidden');
          });
      }

      async hasAnotherVariantInCart() {
        const productId = Number(
          this.dataset.productId
        );

        const selectedVariantId = Number(
          this.variantIdInput.value
        );

        if (!productId || !selectedVariantId) {
          return false;
        }

        try {
          const response = await fetch(
            `${routes.cart_url}.js`,
            {
              headers: {
                Accept: 'application/json',
              },
            }
          );

          if (!response.ok) {
            return false;
          }

          const cart = await response.json();

          return cart.items.some(
            (item) =>
              Number(item.product_id) ===
                productId &&
              Number(item.variant_id) !==
                selectedVariantId
          );
        } catch (error) {
          console.warn(
            'Unable to check product variants in the cart.',
            error
          );

          return false;
        }
      }

      showSizeVariantWarning(
        selectedVariantId
      ) {
        let warning = document.getElementById(
          `SizeVariantWarning-${this.dataset.sectionId}`
        );

        if (!warning) {
          warning = document.createElement('div');

          warning.id =
            `SizeVariantWarning-${this.dataset.sectionId}`;

          warning.className =
            'size-variant-warning';

          warning.setAttribute(
            'role',
            'alert'
          );

          warning.innerHTML = `
            <button
              type="button"
              class="size-variant-warning__close"
              aria-label="Close size warning"
            >
              &times;
            </button>

            <p class="size-variant-warning__title">
              Adding another size to your cart?
            </p>

            <p class="size-variant-warning__text">
              You have already added another size of
              this product. Please check your selected
              size first. If you are unsure, use the

              <button
                type="button"
                class="size-variant-warning__vfr-link"
              >
                Virtual Fitting Room
              </button>

              for a personalised size recommendation.
              Close this message and click Add to cart
              again to continue.
            </p>
          `;

          const variantPicker =
            document.getElementById(
              `variant-selects-${this.dataset.sectionId}`
            );

          const optionGroups = variantPicker
            ? Array.from(
                variantPicker.querySelectorAll(
                  '.product-form__input'
                )
              )
            : [];

          const sizeOption =
            optionGroups.find((group) => {
              const label = group.querySelector(
                'legend, label.form__label'
              );

              return label?.textContent
                .trim()
                .toLowerCase()
                .startsWith('size');
            });

          if (sizeOption) {
            sizeOption.insertAdjacentElement(
              'afterend',
              warning
            );
          } else if (variantPicker) {
            variantPicker.appendChild(warning);
          } else {
            this.insertAdjacentElement(
              'beforebegin',
              warning
            );
          }

          const closeButton =
            warning.querySelector(
              '.size-variant-warning__close'
            );

          closeButton.addEventListener(
            'click',
            () => {
              this.confirmedVariantId = Number(
                this.variantIdInput.value
              );

              this.hideSizeVariantWarning();
              this.submitButton.focus();
            }
          );

          const fittingRoomLink =
            warning.querySelector(
              '.size-variant-warning__vfr-link'
            );

          fittingRoomLink.addEventListener(
            'click',
            async (event) => {
              const link =
                event.currentTarget;

              const originalText =
                'Virtual Fitting Room';

              link.disabled = true;

              link.textContent =
                'Opening Virtual Fitting Room…';

              const sizebayButton =
                await this.waitForSizebayButton();

              if (sizebayButton) {
                link.disabled = false;

                link.textContent =
                  originalText;

                this.confirmedVariantId =
                  Number(
                    this.variantIdInput.value
                  );

                this.hideSizeVariantWarning();

                sizebayButton.click();
              } else {
                link.textContent =
                  'Virtual Fitting Room unavailable';

                setTimeout(() => {
                  link.disabled = false;

                  link.textContent =
                    originalText;
                }, 2500);
              }
            }
          );
        }

        warning.dataset.variantId =
          String(selectedVariantId);

        warning.hidden = false;

        warning.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
        });
      }

      hideSizeVariantWarning() {
        const warning =
          document.getElementById(
            `SizeVariantWarning-${this.dataset.sectionId}`
          );

        if (warning) {
          warning.hidden = true;
        }
      }

      waitForSizebayButton() {
        const existingButton =
          document.getElementById(
            'szb-vfr-button'
          );

        if (existingButton) {
          return Promise.resolve(
            existingButton
          );
        }

        return new Promise((resolve) => {
          let timeout;

          const observer =
            new MutationObserver(() => {
              const button =
                document.getElementById(
                  'szb-vfr-button'
                );

              if (button) {
                observer.disconnect();
                clearTimeout(timeout);
                resolve(button);
              }
            });

          observer.observe(document.body, {
            childList: true,
            subtree: true,
          });

          timeout = setTimeout(() => {
            observer.disconnect();
            resolve(null);
          }, 5000);
        });
      }

      handleErrorMessage(
        errorMessage = false
      ) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            '.product-form__error-message-wrapper'
          );

        if (!this.errorMessageWrapper) {
          return;
        }

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute(
          'hidden',
          !errorMessage
        );

        if (errorMessage) {
          this.errorMessage.textContent =
            errorMessage;
        }
      }

      toggleSubmitButton(
        disable = true,
        text
      ) {
        if (disable) {
          this.submitButton.setAttribute(
            'disabled',
            'disabled'
          );

          if (text) {
            this.submitButtonText.textContent =
              text;
          }
        } else {
          this.submitButton.removeAttribute(
            'disabled'
          );

          this.submitButtonText.textContent =
            window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector(
          '[name=id]'
        );
      }
    }
  );
}